import { createMuiTheme } from "@material-ui/core/styles";

export const theme = {
  colors: {
    light000: "rgba(255, 255, 255)",
    light300: "rgba(218, 219, 225, 1)",
    light500: "rgb(140, 127, 127)",
    light600: "rgb(85, 85, 85)",
    light700: "rgba(60, 60, 60, 1)",
    light800: "#1D1F27",
    light900: "rgba(0, 0, 0, 0.9)",
    pink500: "rgba(234, 197, 255, 1)",
    pink600: "rgba(199, 168, 216, 1)",
    purpleToPink: "linear-gradient(0deg, rgba(234, 197, 255, 1) 0%, rgba(102, 86, 171, 1) 100%)",
    purple900: "rgba(102, 86, 171, 1)",
    red500: "rgb(255, 48, 33)",
    teal500: "rgb(27, 185, 160, 1)",
    teal800: "rgb(23, 85, 79)",
    blue500: "#2196f3",
    green500: "#4caf50",
    orange500: "#ff9800",
    yellow500: "rgb(247, 224, 24, 1)",
    yellow500a08: "rgb(247, 224, 24, 0.8)",
    yellow800: "rgb(181, 165, 24, 1)",
    yellow800a06: "rgb(181, 165, 24, .6)",
  },
};

export const materialTheme = createMuiTheme({
  palette: {
    type: "dark",
    primary: {
      main: "rgb(247, 224, 24, 1)",
    },
  },
});
